import styled from 'styled-components';

export const TableHead = styled.thead`
  th {
    width: 175px;
  }
  th:last-child {
    width: auto;
`;
